var _excluded = ["quantityInitialValue", "quantityMultiplier", "quantityMaxValue", "onAdd", "onAddToList", "addLabel", "addToolTipLabel", "addToListLabel", "addToListToolTipLabel", "quantityLabel", "table", "addToCartLoading", "addToListLoading", "noAddToCart", "disabled", "quantityRounded", "quantitySmall", "addToCartRound", "id", "addToListDataTrackClass", "addToListDataTrackId", "addToCartDataTrackClass", "addToCartDataTrackId", "addToCartNotAllowedText", "customValidation", "quantityOnChange"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState } from 'react';
import Icon from '../Icon';
import { CartIcon, ListIcon } from '../Icons';
import { Wrapper, Quantity, QuantityLabel, AddToCartButton, AddToListButton, Message } from './style';
import Button from '../Button';
import QuantityCounterV2 from '../QuantityCounterV2';
import { ErrorMessage } from '../QuantityCounterV2/styles';

// TODO: Delete when Button converted to typescript
var ButtonAnyProps = Button;
var AddToCart = function AddToCart(props) {
  var quantityInitialValue = props.quantityInitialValue,
    quantityMultiplier = props.quantityMultiplier,
    quantityMaxValue = props.quantityMaxValue,
    onAdd = props.onAdd,
    onAddToList = props.onAddToList,
    addLabel = props.addLabel,
    addToolTipLabel = props.addToolTipLabel,
    addToListLabel = props.addToListLabel,
    addToListToolTipLabel = props.addToListToolTipLabel,
    quantityLabel = props.quantityLabel,
    _props$table = props.table,
    table = _props$table === void 0 ? false : _props$table,
    _props$addToCartLoadi = props.addToCartLoading,
    addToCartLoading = _props$addToCartLoadi === void 0 ? false : _props$addToCartLoadi,
    _props$addToListLoadi = props.addToListLoading,
    addToListLoading = _props$addToListLoadi === void 0 ? false : _props$addToListLoadi,
    _props$noAddToCart = props.noAddToCart,
    noAddToCart = _props$noAddToCart === void 0 ? false : _props$noAddToCart,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$quantityRounde = props.quantityRounded,
    quantityRounded = _props$quantityRounde === void 0 ? false : _props$quantityRounde,
    _props$quantitySmall = props.quantitySmall,
    quantitySmall = _props$quantitySmall === void 0 ? false : _props$quantitySmall,
    _props$addToCartRound = props.addToCartRound,
    addToCartRound = _props$addToCartRound === void 0 ? false : _props$addToCartRound,
    id = props.id,
    _props$addToListDataT = props.addToListDataTrackClass,
    addToListDataTrackClass = _props$addToListDataT === void 0 ? null : _props$addToListDataT,
    _props$addToListDataT2 = props.addToListDataTrackId,
    addToListDataTrackId = _props$addToListDataT2 === void 0 ? null : _props$addToListDataT2,
    _props$addToCartDataT = props.addToCartDataTrackClass,
    addToCartDataTrackClass = _props$addToCartDataT === void 0 ? null : _props$addToCartDataT,
    _props$addToCartDataT2 = props.addToCartDataTrackId,
    addToCartDataTrackId = _props$addToCartDataT2 === void 0 ? null : _props$addToCartDataT2,
    addToCartNotAllowedText = props.addToCartNotAllowedText,
    customValidation = props.customValidation,
    quantityOnChange = props.quantityOnChange,
    rest = _objectWithoutProperties(props, _excluded);
  var _useState = useState(quantityInitialValue),
    _useState2 = _slicedToArray(_useState, 2),
    quantity = _useState2[0],
    setQuantity = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    quantityError = _useState4[0],
    setQuantityError = _useState4[1];
  var addToCart = function addToCart() {
    return onAdd(quantity);
  };
  var addToList = function addToList() {
    return typeof onAddToList === 'function' ? onAddToList(quantity) : null;
  };
  var handleChangeQuantity = function handleChangeQuantity(_ref) {
    var value = _ref.value,
      _ref$error = _ref.error,
      hasError = _ref$error.hasError,
      message = _ref$error.message;
    if (quantityOnChange) quantityOnChange(value);
    setQuantity(value);
    hasError ? setQuantityError(message) : setQuantityError('');
  };
  var quantityCounter = /*#__PURE__*/React.createElement(QuantityCounterV2, {
    id: "change-quantity-".concat(id),
    "date-testid": "change-quantity-".concat(id),
    name: "counter",
    initialValue: quantityInitialValue,
    onChange: handleChangeQuantity,
    multiplier: quantityMultiplier,
    maxValue: quantityMaxValue,
    hideMessage: !table,
    disabled: disabled,
    rounded: quantityRounded,
    small: quantitySmall,
    customValidation: customValidation
  });
  var marginBottom = !!quantityError && !!addToListLabel;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Wrapper, _extends({
    table: table
  }, rest, {
    marginBottom: marginBottom
  }), /*#__PURE__*/React.createElement(Quantity, {
    table: table
  }, !table && /*#__PURE__*/React.createElement(QuantityLabel, null, quantityLabel), quantityCounter), noAddToCart && !addToCartLoading && /*#__PURE__*/React.createElement(Message, null, addToCartNotAllowedText), !noAddToCart && /*#__PURE__*/React.createElement(AddToCartButton, {
    table: table
  }, addToCartRound ? /*#__PURE__*/React.createElement(ButtonAnyProps, {
    id: "add-to-cart-".concat(id),
    "data-testid": "add-to-cart-".concat(id),
    variant: "roundprimary",
    size: "regular",
    onClick: addToCart,
    leftIcon: null,
    title: addToolTipLabel || addLabel,
    text: null,
    isLoading: addToCartLoading,
    "data-quantity": Number.isNaN(quantity) ? 0 : quantity,
    dataTrackClass: addToCartDataTrackClass,
    dataTrackId: addToCartDataTrackId,
    disabled: disabled || !!quantityError
  }, /*#__PURE__*/React.createElement(Icon, {
    as: CartIcon
  })) : /*#__PURE__*/React.createElement(ButtonAnyProps, {
    id: "add-to-cart-".concat(id),
    "data-testid": "add-to-cart-".concat(id),
    variant: table ? 'squareprimary' : 'primary',
    size: "large",
    onClick: addToCart,
    leftIcon: table ? null : /*#__PURE__*/React.createElement(Icon, {
      as: CartIcon
    }),
    title: addToolTipLabel || addLabel,
    text: table ? null : addLabel,
    isLoading: addToCartLoading,
    "data-quantity": Number.isNaN(quantity) ? 0 : quantity,
    dataTrackClass: addToCartDataTrackClass,
    dataTrackId: addToCartDataTrackId,
    disabled: disabled || !!quantityError
  }, table && /*#__PURE__*/React.createElement(Icon, {
    as: CartIcon
  }))), onAddToList && addToListLabel && /*#__PURE__*/React.createElement(AddToListButton, {
    table: table
  }, /*#__PURE__*/React.createElement(ButtonAnyProps, {
    id: "add-to-list-".concat(id),
    "data-testid": "add-to-list-".concat(id),
    variant: table ? 'squaresecondary' : 'secondary',
    size: "large",
    leftIcon: table ? null : /*#__PURE__*/React.createElement(Icon, {
      as: ListIcon
    }),
    onClick: addToList,
    title: addToListToolTipLabel || addToListLabel,
    isLoading: addToListLoading,
    text: table ? null : addToListLabel,
    dataTrackClass: addToListDataTrackClass,
    dataTrackId: addToListDataTrackId,
    disabled: disabled
  }, table && /*#__PURE__*/React.createElement(Icon, {
    as: ListIcon
  })))), quantityError && !table && /*#__PURE__*/React.createElement(ErrorMessage, null, quantityError));
};
export default AddToCart;